import T from 'ha/i18n/defineKey';

export const TypesAlgolia = {
  APARTMENT: 3,
  HOUSE: 1,
  BUILDING: 2,
};

export const KindsAlgolia = {
  ENTIRE_PLACE: 0,
  PRIVATE_ROOM: 1,
  SHARED_ROOM: 2,
};

export const Types = {
  Apartment: 3,
  House: 1,
  Building: 2,
};

export const TypesEnum = {
  Apartment: 'APARTMENT',
  House: 'HOUSE',
  Building: 'BUILDING',
};

export const TypesTranslations = {
  1: T('House'),
  2: T('Building'),
  3: T('Apartment'),
};

export const Kinds = {
  EntirePlace: 0,
  PrivateRoom: 1,
  SharedRoom: 2,
};

export const KindsEnum = {
  EntirePlace: 'ENTIRE_PLACE',
  PrivateRoom: 'ROOM',
  SharedRoom: 'SHARED',
};

export const KindsTranslations = {
  0: T('Entire place'),
  1: T('Private room'),
  2: T('Shared room'),
};

export const EntirePlaceTypeTranslations = {
  1: T('Entire house'),
  2: T('Entire building'),
  3: T('Entire apartment'),
};
